/**
 * Layout: Contact Form
 * Slug: contact_form
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.contact_form-layout');

	layouts.forEach((layout) => {
		
	});
});
